import React from 'react';

// splits "foo *bar* baz" into plain text + bold runs, mirroring WhatsApp's *bold* markdown
const renderMessageBody = (text) => {
  const lines = text.split('\n');
  return lines.map((line, i) => (
    <React.Fragment key={i}>
      {line
        .split(/(\*[^*]+\*)/g)
        .filter((part) => part !== '')
        .map((part, j) =>
          part.startsWith('*') && part.endsWith('*') && part.length > 1 ? (
            <strong key={j}>{part.slice(1, -1)}</strong>
          ) : (
            <React.Fragment key={j}>{part}</React.Fragment>
          ),
        )}
      {i < lines.length - 1 ? <br /> : null}
    </React.Fragment>
  ));
};

const WhatsAppPreview = ({ messageText, buttonLink, createdAt, success }) => {
  if (!messageText) {
    return (
      <div
        style={{
          padding: '16px',
          textAlign: 'center',
          color: '#8a8a8a',
          fontSize: '13px',
          background: '#f5f6f7',
          borderRadius: '8px',
        }}
      >
        Message preview isn&apos;t available for this notification.
      </div>
    );
  }

  const time = createdAt
    ? new Date(createdAt).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })
    : '';

  return (
    <div style={{ borderRadius: '10px', overflow: 'hidden', border: '1px solid #d4d7dc', maxWidth: '360px' }}>
      <div style={{ background: '#075E54', color: '#fff', padding: '10px 14px', display: 'flex', alignItems: 'center', gap: '10px' }}>
        <div
          style={{
            width: '32px',
            height: '32px',
            borderRadius: '50%',
            background: '#fff',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            color: '#075E54',
            fontWeight: 700,
            fontSize: '14px',
          }}
        >
          DH
        </div>
        <div>
          <div style={{ fontSize: '14px', fontWeight: 600 }}>Danube Home</div>
          <div style={{ fontSize: '11px', opacity: 0.8 }}>Business Account</div>
        </div>
      </div>

      <div style={{ background: '#e5ddd5', padding: '14px', minHeight: '120px' }}>
        <div
          style={{
            background: '#dcf8c6',
            borderRadius: '8px',
            padding: '8px 10px',
            marginLeft: 'auto',
            maxWidth: '90%',
            boxShadow: '0 1px 1px rgba(0,0,0,0.15)',
          }}
        >
          <div style={{ fontSize: '13.5px', color: '#111', lineHeight: 1.4 }}>
            {renderMessageBody(messageText)}
          </div>

          {buttonLink ? (
            <div
              style={{
                marginTop: '8px',
                paddingTop: '6px',
                borderTop: '1px solid rgba(0,0,0,0.08)',
                display: 'flex',
                alignItems: 'center',
                gap: '6px',
                color: '#00a5f4',
                fontSize: '13px',
                fontWeight: 500,
                wordBreak: 'break-all',
              }}
            >
              <i className="bx bx-link-alt"></i> {buttonLink}
            </div>
          ) : null}

          <div style={{ fontSize: '10.5px', color: '#667781', textAlign: 'right', marginTop: '4px' }}>
            {time}{' '}
            <i
              className={success ? 'mdi mdi-check-all' : 'mdi mdi-check'}
              style={{ color: success ? '#53bdeb' : '#667781' }}
            ></i>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WhatsAppPreview;
